import { HTTPStatusCodes } from '@omnipresentgroup/constants';
import type {
  CreateInvoicePaymentRequestAPI,
  CreateInvoicePaymentResponseAPI,
  CreateInvoiceQuoteRequestAPI,
  CreateInvoiceQuoteResponseAPI,
  CreateInvoiceRequestAPI,
  GetContractorInvoiceResponseAPI,
  GetContractorInvoicesResponseAPI,
} from '@omnipresentgroup/types';
import { delay, HttpResponse, http } from 'msw';

import { API_PATH } from './constants';
import {
  CONTRACTOR_INVOICES_QUOTE_WITH_BREAKDOWN,
  DEFAULT_CONTRACTOR_INVOICE,
  DEFAULT_CONTRACTOR_INVOICES_PAYMENT_DETAILS,
  DEFAULT_CONTRACTOR_INVOICES_QUOTE,
  DEFAULT_CONTRACTOR_INVOICES_REPORT,
  DEFAULT_CONTRACTORS_INVOICES,
  DEFAULT_CONTRACTORS_INVOICES_RESPONSE,
} from './fixtures';

export const contractorsInvoicesHandlers = [
  http.get<never, never, GetContractorInvoicesResponseAPI>(
    `*${API_PATH}`,
    () => {
      return HttpResponse.json(DEFAULT_CONTRACTORS_INVOICES_RESPONSE, {
        status: HTTPStatusCodes.OK,
      });
    },
  ),
  http.post<never, CreateInvoiceRequestAPI, GetContractorInvoiceResponseAPI>(
    `*${API_PATH}`,
    async () => {
      return HttpResponse.json(DEFAULT_CONTRACTOR_INVOICE, {
        status: HTTPStatusCodes.OK,
      });
    },
  ),
  http.put<{ id: string }, never, GetContractorInvoiceResponseAPI>(
    `*/${API_PATH}/:id/cancel`,
    () => {
      return HttpResponse.json(DEFAULT_CONTRACTOR_INVOICE, {
        status: HTTPStatusCodes.OK,
      });
    },
  ),
  http.post<never, CreateInvoiceQuoteRequestAPI, CreateInvoiceQuoteResponseAPI>(
    `*${API_PATH}/quotes`,
    async ({ request }) => {
      const payload = await request.json();
      const result =
        // eslint-disable-next-line no-magic-numbers
        payload.invoices.length === 1
          ? DEFAULT_CONTRACTOR_INVOICES_QUOTE
          : CONTRACTOR_INVOICES_QUOTE_WITH_BREAKDOWN;

      return HttpResponse.json(result, {
        status: HTTPStatusCodes.OK,
      });
    },
  ),
  http.post<
    never,
    CreateInvoicePaymentRequestAPI,
    CreateInvoicePaymentResponseAPI
  >(`*${API_PATH}/payments`, async () => {
    // eslint-disable-next-line no-magic-numbers
    await delay(2000);
    return HttpResponse.json(DEFAULT_CONTRACTOR_INVOICES_PAYMENT_DETAILS, {
      status: HTTPStatusCodes.OK,
    });
  }),
  http.get<{ id: string }, never, GetContractorInvoiceResponseAPI>(
    `*/${API_PATH}/:id`,
    ({ params }) => {
      return HttpResponse.json(
        DEFAULT_CONTRACTORS_INVOICES.find(
          (invoice) => invoice.id === params.id,
        ),
        { status: HTTPStatusCodes.OK },
      );
    },
  ),
  http.get(`*${API_PATH}/report`, () => {
    return HttpResponse.json(DEFAULT_CONTRACTOR_INVOICES_REPORT, {
      status: HTTPStatusCodes.OK,
    });
  }),
];
